export { default } from './NutritionalTable';
export { default as adapter } from './adapter';
